import { LinkBox } from "Components"
import { graphql, StaticQuery } from "gatsby"
import React from "react"
import Collapsible from "react-collapsible"
import styled from "styled-components"
import { FullWrapper } from "Styles"
import { theme } from "Theme"

const { colors, fontSize } = theme

const Wrapper = styled.div`
  font-size: ${fontSize.small};
  background-color: ${(props) => (props.transparentFooter ? colors.transparent : colors.background.dark)};
  color: ${(props) => (props.transparentFooter ? colors.black.light : colors.white.base)};
  ${(props) => (props.transparentFooter ? `border-top: 1px solid ${colors.white.grey}` : ``)};
  text-align: center;
  height: auto;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
    position: relative;
    bottom: 0;
    width: 100%;
    padding-bottom: 0px;
  }

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const StyledFullWrapper = styled(FullWrapper)`
  margin: 0;
  padding: 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 0 1rem;
    margin: 0 auto;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Content = styled.div`
  width: 100%;
  padding: 0 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .Collapsible {
    overflow: hidden;
    position: relative;
    .Collapsible__trigger {
      color: ${theme.colors.white.base};
      font-size: ${theme.fontSize.p};
      border-bottom: 1px solid ${theme.colors.white.grey};
      display: inline;
      max-width: ${theme.layout.base};
      padding: 1rem 0;
      margin: 0;
      cursor: pointer;
      position: relative;
      border: none;
      span {
        position: relative;
        &:after {
          color: ${theme.colors.primary.base};
          background-color: transparent;
          position: relative;
          // border: 1px solid ${theme.colors.white.grey};
          background-image: url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB2ZXJzaW9uPScxLjEnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zycgd2lkdGg9JzEwcHgnIGhlaWdodD0nMTBweCcgdmlld0JveD0nMCAwIDEwIDEwJz48cGF0aCBkPSdNMSw4IEw2LDMgTTUsMyBMMTAsOCcgZmlsbD0nbm9uZScgc3Ryb2tlPScjOGM4YzhjJyBzdHJva2Utd2lkdGg9JzEnLz48L3N2Zz4=);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 1rem;
          content: "";
          height: 1rem;
          position: absolute;
          right: -24px;
          top: 3px;
          transition: ${theme.transitions.default.transition};
          width: 1rem;
          // border-radius: ${theme.borderRadius.elements};
        }
      }
    }
    &.collapsible-open {
      .Collapsible__contentInner {
      }
      .Collapsible__contentOuter {
        border-top: 1px solid ${theme.colors.black.light};
        margin-top: 1rem;
      }
      .Collapsible__trigger.is-open {
        span:after {
          transform: rotate(-180deg);
        }
      }
    }
  }
`

const LocaleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
  padding: 1rem 0;
`

const LocaleItem = styled.div`
  display: inline-block;
  color: inherit;
  font-weight: bold;
  text-align: left;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 6px 0;
  img {
    height: 16px;
    width: auto;
    margin: 0 6px 0 0;
  }
`

class FooterLocale extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentModal: null,
      currentAudience: null,
      currentRegion: null,
    }
  }

  componentDidMount() {
    this.setState({
      currentModal: null,
      currentAudience: null,
      currentRegion: "us",
    })
  }

  render() {
    const { big, dark, region } = this.props
    let currentRegionHTML

    switch (region) {
      case "us":
        currentRegionHTML = (
          <LocaleItem style={{ margin: "1rem 0" }}>
            <img src={"/cdn/flags/US.png"} alt={`${"United State"} Flag`} title={`${"United State"} Flag`} width="16" />
            <span>{"United State"}</span>
          </LocaleItem>
        )
        break
      case "uk":
        currentRegionHTML = (
          <LocaleItem style={{ margin: "1rem 0" }}>
            <img
              src={"/cdn/flags/GB.png"}
              alt={`${"United Kingdom"} Flag`}
              title={`${"United Kingdom"} Flag`}
              width="16"
            />
            <span>{"United Kingdom"}</span>
          </LocaleItem>
        )
        break
      default:
        return ""
    }

    return (
      <StaticQuery
        query={graphql`
          query FooterLocaleQuery {
            content: footerJson {
              regions {
                name
                displayName
                url
                flag
              }
            }
          }
        `}
        render={(data) => (
          <Wrapper transparentFooter={false} dark={dark ? 1 : undefined} big={big}>
            <StyledFullWrapper>
              <Content>
                <Collapsible
                  transitionTime={250}
                  triggerTagName={"div"}
                  trigger={currentRegionHTML}
                  className={"collapsible-default"}
                  openedClassName={"collapsible-open"}>
                  <LocaleGrid>
                    {data.content.regions.map((object, i) => (
                      <LinkBox
                        key={i}
                        to={object.url}
                        alt={`${object.displayName}`}
                        title={`${object.displayName}`}
                        target="self"
                        track={"Footer Locale Links"}
                        rel="nofollow noopener noreferrer">
                        <LocaleItem>
                          <img
                            src={object.flag}
                            alt={`${object.displayName} Flag`}
                            title={`${object.displayName} Flag`}
                            width="16"
                          />
                          {object.displayName}
                        </LocaleItem>
                      </LinkBox>
                    ))}
                  </LocaleGrid>
                </Collapsible>
              </Content>
            </StyledFullWrapper>
          </Wrapper>
        )}
      />
    )
  }
}

export default FooterLocale
